import Avatar from '@atlaskit/avatar';
import Button from '@atlaskit/button';
import { B400 } from '@atlaskit/theme/colors';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { fontFamily } from '../font';
import { messages } from '../messages';

export type TriggerProps = {
  readonly avatarSrc?: string;
  readonly isLoggedIn: boolean;
  readonly userName: string;
  readonly onLogInClick: () => void;
};

export class Trigger extends Component<TriggerProps> {
  public render() {
    const { avatarSrc, isLoggedIn, userName, onLogInClick } = this.props;
    if (isLoggedIn) {
      return (
        <RootContainer>
          <Avatar
            src={avatarSrc}
            name={userName}
            size="small"
            enableTooltip
            isInteractive
          />
        </RootContainer>
      );
    } else {
      return (
        <RootContainer>
          <Button
            appearance={'subtle'}
            onClick={onLogInClick}
            iconAfter={
              <TriggerContainer>
                <TitleLabel>
                  <FormattedMessage {...messages.logOutTriggerText} />
                </TitleLabel>
              </TriggerContainer>
            }
          ></Button>
        </RootContainer>
      );
    }
  }
}

const RootContainer = styled.div`
  &:hover {
    cursor: pointer;
  }
`;

const TriggerContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TitleLabel = styled.span`
  font-family: ${fontFamily};
  font-size: 14px;
  color: ${B400};

  @media only screen and (max-width: 999px) {
    font-size: 12px;
  }
`;
